import * as C from '../constants';

export default {
  setSelectedDomainId({ commit }, domainId) {
    commit(C.SKI_DOMAIN_SET, domainId);
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/ski/actions.js